import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useMe } from '../api/queries';
import { ErrorState } from '../ui';
import { rememberReturnTo } from '../auth/flow';
import { FullPageLoader } from './FullPageLoader';
import { AuthFrame } from '../auth/AuthFrame';

/** Signed-in routes. Remembers where you were headed across the wallet round trip. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <FullPageLoader />;
  if (me.isError) {
    return (
      <AuthFrame>
        <div className="auth-card">
          <ErrorState error={me.error} onRetry={() => void me.refetch()} what="your session" />
        </div>
      </AuthFrame>
    );
  }
  if (!me.data) {
    rememberReturnTo(location.pathname + location.search);
    return <Navigate to="/signin" replace />;
  }
  return <>{children}</>;
}
